import { PanelGroup } from 'components/shared/PanelGroup/PanelGroup';
import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import { CollapseErrorDetails } from 'components/shared/WorkflowError/CollapseDetails';
import { ErrorMessagesContext } from 'contexts/errorMessages/ErrorMessages.context';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FC, useContext } from 'react';
import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { IWorkflowError } from 'utils/errors/workflowErrors';

import { ErrorMessage } from './ErrorMessage/ErrorMessage';
import { getPanelTitleFromErrorMessage } from './List.helper';

export interface IOwnProps {}

export type ListProps = IOwnProps;

const id = 'errors-panel-details-list';

/**
 * @deprecated Use <WorkflowErrorDetailsList /> and <WorkflowErrorDetailsListLegacy />  instead
 */
export const List: FC<ListProps> = () => {
  const { errorMessages = [], shouldUseRejectionCode } = useContext(ErrorMessagesContext);
  const { formatMessage } = useIntl();
  const isInternalUser = useIsInternalUser();
  const hasErrors = errorMessages.length > 0;
  const hasOnlyOneError = errorMessages.length === 1;
  const formatTitle = (errorMessage: IWorkflowError) => {
    const defaultMsg = formatMessage({ id: 'pleaseContactSupport' });
    if (!isInternalUser) {
      return defaultMsg;
    }
    return getPanelTitleFromErrorMessage(errorMessage, shouldUseRejectionCode) ?? defaultMsg;
  };

  return (
    <div className={`${id}-component ${hasOnlyOneError ? 'has-only-one-error' : ''}`} data-e2e={id} id={id}>
      {hasErrors && (
        <PanelGroup e2e={`${id}-panel-group`} id={`${id}-panel-group`}>
          {errorMessages.map((errorMessage, index: number) => (
            <WithToggle isInitiallyOn={hasOnlyOneError} key={index}>
              {({ isOn, toggle }) => (
                <div className="border border-top-0" data-e2e={`${id}-panel`}>
                  <CollapseErrorDetails
                    isOpen={isOn}
                    toggleOpen={toggle}
                    canOpen={isInternalUser}
                    title={formatTitle(errorMessage)}
                  >
                    <ErrorMessage errorMessage={errorMessage} />
                  </CollapseErrorDetails>
                </div>
              )}
            </WithToggle>
          ))}
        </PanelGroup>
      )}
      {!hasErrors && (
        <Alert variant="danger">
          <strong>{formatMessage({ id: 'errorDetails.errorDetailsCanNotBeDisplayed' })}</strong>
          &nbsp;
          {formatMessage({ id: 'pleaseContactSupport' })}
        </Alert>
      )}
    </div>
  );
};
